import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { updateTiming } from "../../../../../store/steps/stepFourSlice";
import ScheduleCard from "./ScheduleCard";
import GenericInput from "../../../../../common/GenericInput";
import { STATIC_STRINGS } from "../../../../../utils/Constants";
import { calculateEndTime } from "../../../../../utils";

const TimePeriod = ({ timing, scheduleSetting, handleOptionClick }) => {
  const dispatch = useDispatch();
  useEffect(() => {
    if (timing.endTime <= timing.startTime) {
      dispatch(
        updateTiming({
          ...timing,
          endTime: calculateEndTime(timing.startTime),
        })
      );
    }
  }, [timing.startTime]);

  return (
    <ScheduleCard
      className="w-[55%] mr-1"
      selected={scheduleSetting === STATIC_STRINGS.TIME_PERIOD}
      title={STATIC_STRINGS.TIME_PERIOD}
      subtitle={STATIC_STRINGS.ASSESSMENT_TIME}
      onClick={() => handleOptionClick(STATIC_STRINGS.TIME_PERIOD)}
    >
      <div className="flex flex-col items-center justify-around xl:items-start xl:flex-row">
        <div className="flex flex-col items-start">
          <label className="font-medium text-gray-600">
            {STATIC_STRINGS.START_TIME}
          </label>
          <GenericInput
            disabled={scheduleSetting !== STATIC_STRINGS.TIME_PERIOD}
            type="datetime-local"
            value={timing.startTime}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              dispatch(updateTiming({ ...timing, startTime: e.target.value }));
            }}
            slotProps={{
              htmlInput: { min: timing.startTime },
            }}
          />
        </div>
        <div className="flex flex-col items-start mt-1 xl:m-0">
          <label className="font-medium text-gray-600">
            {STATIC_STRINGS.END_TIME}
          </label>
          <GenericInput
            disabled={scheduleSetting !== STATIC_STRINGS.TIME_PERIOD}
            type="datetime-local"
            value={timing.endTime}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              dispatch(updateTiming({ ...timing, endTime: e.target.value }));
            }}
            slotProps={{
              htmlInput: { min: timing.startTime },
            }}
          />
        </div>
      </div>
    </ScheduleCard>
  );
};
export default TimePeriod;
